export {default} from './TextLinkLayout.js';



// WEBPACK FOOTER //
// ./~/wix-style-react/src/BaseComponents/TextLinkLayout/index.js